module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0082.jpg?v=68aac5a1";